import { gsap } from "./gsap";

export interface ProjectsShowcaseVars {
  section: HTMLElement;
  pin: HTMLElement;
  progressLine: gsap.DOMTarget;
  onUpdate: (index: number) => void;
}

export function createProjectsShowcase({ section, pin, progressLine, onUpdate }: ProjectsShowcaseVars): void {
  const visuals = gsap.utils.toArray<HTMLElement>(".project-visual");
  const metas = gsap.utils.toArray<HTMLElement>(".project-meta");
  const count = Math.min(visuals.length, metas.length);
  if (count < 2) return;

  const end = () => `+=${count * 92}%`;

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: section,
      start: "top top",
      end,
      pin,
      scrub: 0.6,
      anticipatePin: 1,
      onUpdate: (self) => onUpdate(Math.min(count - 1, Math.floor(self.progress * count + 0.0001))),
    },
  });

  for (let i = 1; i < count; i++) {
    const at = i / count;
    tl.to([visuals[i - 1], metas[i - 1]], { opacity: 0, y: -56, duration: 0.16, ease: "power2.in" }, at - 0.085).fromTo(
      [visuals[i], metas[i]],
      { opacity: 0, y: 56 },
      { opacity: 1, y: 0, duration: 0.16, ease: "power2.out" },
      at + 0.085
    );
  }

  gsap.fromTo(
    progressLine,
    { scaleX: 0 },
    { scaleX: 1, ease: "none", scrollTrigger: { trigger: section, start: "top top", end, scrub: 0.6 } }
  );
}
